import { memo } from 'react';
import FloatingMenu from '../widgets/FloatingMenu';
import { ReviewerCopilotButton } from './buttons/copilot';
import { useCurrentEditor } from '@tiptap/react';

function PreviewFloatingMenu() {
  const { editor } = useCurrentEditor();
  if (!editor) return null;

  return (
    <>
      <FloatingMenu
        name="ReadOnlyFloatingMenu"
        shouldShow={({ editor }) => !editor.isEditable && !editor.state.selection.empty}
      >
        <ReviewerCopilotButton />
      </FloatingMenu>
    </>
  );
}

export default memo(PreviewFloatingMenu);
